exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".col-auto[data-v-2028d8ed] {\n  padding-left: 0px;\n}\n", ""]);

